<script lang="ts">
  // Compact crowding report control for the boarded/riding panel. Wrapped as its own
  // component so `createCrowding` (and its fetch effect) only mounts when a vehicle is
  // being tracked — RidingPanel renders nothing when trackedVehicle is null, so the
  // rune module can't live at its top level.
  import type { VehiclePosition } from '../../store/transit'
  import { createCrowding } from '../Map/crowding.svelte'
  import CrowdingReport from '../Map/CrowdingReport.svelte'

  interface Props {
    vehicle: VehiclePosition
    accentColor: string
    /** Passed straight through — see `CrowdingReport`. Layout only; there is one paint. */
    layout?: 'stack' | 'row'
  }

  const { vehicle, accentColor, layout }: Props = $props()

  const crowding = createCrowding(() => vehicle)
</script>

<CrowdingReport {crowding} {accentColor} {layout} />
